export const basename = (fileName) => fileName.replace(/\.[^/.]+$/, '');
export const extname = (fileName) => fileName.includes('.') ? `.${fileName.split('.').pop()}` : '';
